<script setup lang="ts">

import logoIdeal from '/assets/logo/ideal.svg';
import {useFlag} from "@unleash/proxy-client-vue";
import type {Currency, PaymentMethod} from "~/types/subscription.types";

const {active} = useSubscriptionForEnvironment()

const props = defineProps<{
  currency: Currency
}>()
const paymentMethod = defineModel<PaymentMethod>()

// These flags are used to disable certain payment methods
// Useful for initial deployments where we don't have all payment methods available
const paypalDisabled = useFlag('PAYMENT_METHOD_PAYPAL_DISABLED')
const idealDisabled = useFlag('PAYMENT_METHOD_IDEAL_DISABLED')
const sepaDisabled = useFlag('PAYMENT_METHOD_SEPA_DISABLED')
const invoiceDisabled = useFlag('PAYMENT_METHOD_INVOICE_DISABLED')


watch([() => props.currency], () => {
  if (props.currency === 'USD') {
    paymentMethod.value = 'CREDIT_CARD_USD'
  } else {
    paymentMethod.value = 'CREDIT_CARD_EUR'
  }
}, {immediate: true})

</script>
<template>
  <div class="my-4" v-if="!active">
    <p class="h5">Which payment method would you like to use?</p>
    <div class="d-flex gap-2 mt-2" v-if="currency === 'USD'">
      <v-btn @click="paymentMethod ='CREDIT_CARD_USD'" color="primary"
             :variant="paymentMethod === 'CREDIT_CARD_USD' ? 'flat' :'tonal'" class="flex-grow-1">
        <CreditCardIcon class="mr-2"/>
        Credit card
      </v-btn>
      <v-btn @click="paymentMethod ='PAYPAL_USD'"
             color="primary"
             :variant="paymentMethod === 'PAYPAL_USD' ? 'flat' :'tonal'" class="flex-grow-1"
             v-if="!paypalDisabled">
        <BrandPaypalIcon class="mr-2"/>
        PayPal
      </v-btn>
      <v-btn color="primary"
             @click="paymentMethod ='INVOICE'"
             :variant="paymentMethod === 'INVOICE' ? 'flat' :'tonal'"
             v-if="!invoiceDisabled">
        <FileInvoiceIcon width="24" class="mr-2"></FileInvoiceIcon>
        Invoice
      </v-btn>
    </div>
    <div class="d-flex gap-2 mt-2 flex-wrap" v-if="currency === 'EUR'">
      <v-btn @click="paymentMethod ='CREDIT_CARD_EUR'" color="primary"
             :variant="paymentMethod === 'CREDIT_CARD_EUR' ? 'flat' :'tonal'">
        <CreditCardIcon class="mr-2"/>
        Credit card
      </v-btn>
      <v-btn @click="paymentMethod ='PAYPAL_EUR'"
             color="primary"
             :variant="paymentMethod === 'PAYPAL_EUR' ? 'flat' :'tonal'"
             v-if="!paypalDisabled">
        <BrandPaypalIcon class="mr-2"/>
        PayPal
      </v-btn>
      <v-btn @click="paymentMethod ='SEPA_DEBIT_EUR'" color="primary"
             :variant="paymentMethod === 'SEPA_DEBIT_EUR' ? 'flat' :'tonal'"
             v-if="!sepaDisabled">
        <BuildingBankIcon class="mr-2"/>
        SEPA Direct Debit
      </v-btn>
      <v-btn color="primary"
             @click="paymentMethod ='IDEAL_EUR'"
             :variant="paymentMethod === 'IDEAL_EUR' ? 'flat' :'tonal'"
             v-if="!idealDisabled">
        <v-img :src="logoIdeal" width="24" class="mr-2"></v-img>
        iDeal
      </v-btn>
      <v-btn color="primary"
             @click="paymentMethod ='INVOICE'"
             :variant="paymentMethod === 'INVOICE' ? 'flat' :'tonal'"
             v-if="!invoiceDisabled">
        <FileInvoiceIcon width="24" class="mr-2"></FileInvoiceIcon>
        Invoice / Bank Transfer
      </v-btn>
    </div>
  </div>
</template>
